var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"Photo"},[_c('figure',{staticClass:"Photo__container"},[_c('img',{staticClass:"Photo__source",attrs:{"alt":"","id":'thumbnail-' + _vm.photo.id,"src":_vm.parkphoto.image},on:{"click":function($event){return _vm.selectThisPhoto(_vm.photo)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }